import { lightTheme } from '@/customTheme'
import { styled } from 'baseui'
import React from 'react'

export const DashboardPage = styled('div', (props: any) => ({
  overflow: 'hidden scroll',
  '::-webkit-scrollbar': { width: '8px', margin: '20px 0' },
  '::-webkit-scrollbar-track': { borderRadius: '4px' },
  '::-webkit-scrollbar-thumb': {
    borderRadius: '4px',
    backgroundColor: '#e5e5e5',
    minHeight: '100px',
  },
  '::-webkit-scrollbar-thumb:hover': {
    cursor: 'pointer',
    backgroundColor: '#D9D9D9',
  },
  position: 'relative',
  width: 'calc(100% - 260px)',
  minWidth: '586px',
  height: 'calc(100vh - 64px)',
  padding: '0 32px',
  display: 'flex',
  flexDirection: 'column',
  marginLeft: '260px',
  '@media screen and (min-width: 1517px)': {
    width: 'calc(100% - 260px)',
    margin: '0 auto',
    marginLeft: '260px',
    padding: '0 32px',
  },
  ...props.style,
}))

type GridItemCardProps = {
  $state?: 'default' | 'loading'
  [key: string]: any
}

export const GridItemCard = styled('div', (props: GridItemCardProps) => ({
  boxSizing: 'border-box',
  position: 'relative',
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  padding: '24px',
  borderRadius: '16px',
  backgroundColor: lightTheme.colors.grayScale50,
  cursor: props.$state === 'loading' ? 'default' : 'pointer',
  overflow: 'hidden',
  ...(props.$state === 'loading' ? {
    backgroundColor: lightTheme.colors.grayScale50,
    pointerEvents: 'none',
  } : {}),
  ...props.style,
}))

type StickyHeaderProps = {
  gap?: string
  paddingBottom?: string
  children: React.ReactNode
}

export function StickyHeader({ gap = '4px', paddingBottom, children }: StickyHeaderProps) {
  return (
    <div
      style={{
        position: 'sticky',
        top: '0px',
        paddingTop: '32px',
        background: '#fff',
        zIndex: 2,
        display: 'flex',
        flexDirection: 'column',
        gap,
        ...(paddingBottom ? { paddingBottom } : {}),
      }}
    >
      {children}
    </div>
  )
}
